import Hero from "../components/Hero";
import Navbar from "../components/Navbar";
import MainPartv2 from "../components/MainPartv2";
//import MainPartv3 from "../components/MainPartv3";
import MainPart from "../components/MainPart";
import Footer from "../components/Footer";

function Sponsors(){
    return(
        <>
            <Navbar/>
            <Hero
                cName="hero-content" 
                heroImg="https://static.igem.wiki/teams/4696/wiki/hhhero-fig12.jpeg"
                title="Sponsors"
            />

            <div className="content-container">

                <div className="sidepanel">
                    <ul>
                        <a href="#1" className="a-sidepanel"><ul class="header">Sponsors</ul></a>
                        <a href="#2" className="a-sidepanel"><ul class="subheader">1. HKU Faculty of Engineering Innovation Wing</ul></a>
                        <a href="#3" className="a-sidepanel"><ul class="subheader">2. HKU Faculty of Medicine</ul></a>
                        <a href="#4" className="a-sidepanel"><ul class="subheader">3. HKU Faculty of Science</ul></a>
                        <a href="#5" className="a-sidepanel"><ul class="subheader">4. THKU BEL Lab</ul></a>
                        <a href="#6" className="a-sidepanel"><ul class="subheader">5. IDT</ul></a>
                        <a href="#7" className="a-sidepanel"><ul class="subheader">6. Asimov</ul></a>
                        <a href="#8" className="a-sidepanel"><ul class="subheader">7. Snapgene</ul></a>
                        <a href="#9" className="a-sidepanel"><ul class="subheader">8. Promega</ul></a>
                    </ul>
                </div>
                <MainPart
                    section_id={1}
                    container_cName="main-paragraph-container"
                    heading="Sponsors"
                    subheading={['HKU iGEM 2023 would like to express our sincerest gratitude to each of our sponsors.'
                    ,<br/>,<br/>,
                    'This project could not have happened without their generosity and support.'
                    ]}
                    paragraph={[
                        
                         
                    ]}
                    img_cName="hide"
                />
                <MainPartv2
                    section_id={2}
                    container_cName="main-paragraph-container"
                    heading_cName='hide'
                    subheading={[
                    <br/>,<br/>,
                    "HKU Faculty of Engineering Innovation Wing"
                    ]}
                    paragraph_cName1="hide"
                    MainPartImg1='https://static.igem.wiki/teams/4696/wiki/spon-fig1.png'
                    img_cName1="MainPartImg"
                    paragraph2={[
                        'Fundraising, Project Administration:', <br/>,
                        'Provided funding and laboratory space for our project. Also provided venue space for us to host education events.'
                         
                    ]}
                    img_cName2="hide"
                    paragraph_cName3="hide"
                    img_cName3="hide"
                />
                <MainPartv2
                    section_id={3}
                    container_cName="main-paragraph-container"
                    heading_cName='hide'
                    subheading={[
                    <br/>,<br/>,
                    "HKU Faculty of Medicine"
                    ]}
                    paragraph_cName1="hide"
                    MainPartImg1='https://static.igem.wiki/teams/4696/wiki/spon-fig2.png'
                    img_cName1="MainPartImg"
                    paragraph2={[
                        'Fundraising, Project Administration:', <br/>,
                        'Provided funding, laboratory space and equipment for the project. '
                         
                    ]}
                    img_cName2="hide"
                    paragraph_cName3="hide"
                    img_cName3="hide"
                />
                <MainPartv2
                    section_id={4}
                    container_cName="main-paragraph-container"
                    heading_cName='hide'
                    subheading={[
                    <br/>,<br/>,
                    "HKU Faculty of Science"
                    ]}
                    paragraph_cName1="hide"
                    MainPartImg1='https://static.igem.wiki/teams/4696/wiki/spon-fig4.png'
                    img_cName1="MainPartImg"
                    paragraph2={[
                        'Fundraising, Project Administration:', <br/>,
                        'Provided funding, laboratory space and equipment for the project. '
                         
                    ]}
                    img_cName2="hide"
                    paragraph_cName3="hide"
                    img_cName3="hide"
                />
                <MainPartv2
                    section_id={5}
                    container_cName="main-paragraph-container"
                    heading_cName='hide'
                    subheading={[
                    <br/>,<br/>,
                    "HKU BEL Lab"
                    ]}
                    paragraph_cName1="hide"
                    MainPartImg1='https://static.igem.wiki/teams/4696/wiki/spon-fig3.png'
                    img_cName1="MainPartImg"
                    paragraph2={[
                        'Project administation, investigation:', <br/>,
                        'Provided assistance, laboratory space and expertise throughout the project.'
                         
                    ]}
                    img_cName2="hide"
                    paragraph_cName3="hide"
                    img_cName3="hide"
                />
                <MainPartv2
                    section_id={6}
                    container_cName="main-paragraph-container"
                    heading_cName='hide'
                    subheading={[
                    <br/>,<br/>,
                    "IDT"
                    ]}
                    paragraph_cName1="hide"
                    MainPartImg1='https://static.igem.wiki/teams/4696/wiki/spon-fig5.png'
                    img_cName1="MainPartImg"
                    paragraph2={[
                        'Investigation:', <br/>,
                        'Provided sponsorship for their gene synthesis products.'
                         
                    ]}
                    img_cName2="hide"
                    paragraph_cName3="hide"
                    img_cName3="hide"
                />
                <MainPartv2
                    section_id={7}
                    container_cName="main-paragraph-container"
                    heading_cName='hide'
                    subheading={[
                    <br/>,<br/>,
                    "Asimov"
                    ]}
                    paragraph_cName1="hide"
                    MainPartImg1='https://static.igem.wiki/teams/4696/wiki/spon-fig6.png'
                    img_cName1="MainPartImg"
                    paragraph2={[
                        'Investigation:', <br/>,
                        'Characterized human parts on our behalf.'
                         
                    ]}
                    img_cName2="hide"
                    paragraph_cName3="hide"
                    img_cName3="hide"
                />
                <MainPartv2
                    section_id={8}
                    container_cName="main-paragraph-container"
                    heading_cName='hide'
                    subheading={[
                    <br/>,<br/>,
                    "Snapgene"
                    ]}
                    paragraph_cName1="hide"
                    MainPartImg1='https://static.igem.wiki/teams/4696/wiki/spon-fig7.png'
                    img_cName1="MainPartImg"
                    paragraph2={[
                        'Investigation:', <br/>,
                        'Provided sponsorship for their software keys.'
                         
                    ]}
                    img_cName2="hide"
                    paragraph_cName3="hide"
                    img_cName3="hide"
                />

                <MainPartv2
                    section_id={9}
                    container_cName="main-paragraph-container"
                    heading_cName='hide'
                    subheading={[
                    <br/>,<br/>,
                    "Promega"
                    ]}
                    paragraph_cName1="hide"
                    MainPartImg1='https://static.igem.wiki/teams/4696/wiki/spon-fig8.png'
                    img_cName1="MainPartImg"
                    paragraph2={[
                        'Investigation:', <br/>,
                        'Provided sponsorship for their products.'
                         
                    ]}
                    img_cName2="hide"
                    paragraph_cName3="hide"
                    img_cName3="hide"
                />









                

            </div>
            <Footer/>
        </>
    )
}

export default Sponsors;